<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      @input="onMenuChange"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-select 
          v-model="form.phoneCode"
          :items="filteredCountries"
          item-text="dial_code"
          item-value="dial_code"
          v-bind="{ ...$attrs, ...attrs }"
          v-on="on"
          required
          @change="onSelect"
          :no-data-text="$t('noinfo')"
        >
          <template v-slot:prepend-item>
            <v-list-item class="py-1" style="position: sticky; top: 0; z-index: 1; background-color: white; border: 1px solid #e0e0e0;">
              <v-text-field
                v-model="searchCountry"
                outlined
                :placeholder="$t('search')"
                prepend-inner-icon="mdi-magnify"
                hide-details
                dense
              ></v-text-field>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item }">
            {{ item.dial_code }}
          </template>
          <template v-slot:item="{ item }">
            <img :src="item.flag_image" class="mr-2" width="30" style="border-radius: 50%;" />
            {{ item.name }} ({{ item.dial_code }})
          </template>
        </v-select>
      </template>
    </v-menu>
  </div>
</template>

<script>
import Countries from '../json/countries.json'
export default {
  props: {
    // value: String,
    phoneCode: String,
    countryName: String,
    countryCode: String,
    flagImage: String,
  },
  data() {
    return {
      Countries,
      searchCountry: '',
      menu: false,
      form: {
        phoneCode: this.phoneCode
      }
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.updateValue()
      }
    }
  },
  created() {
    this.updateValue()
  },
  computed: {
    options() {
      return this.Countries.filter(country => country.continent == "Asia" && country.isAsean)
    },
    filteredCountries() {
      return this.options.filter(country => 
        country.name.toLowerCase().includes(this.searchCountry.toLowerCase()) || 
        country.dial_code.includes(this.searchCountry)
      )
    }
  },
  methods: {
    updateValue(value) {
      let data = this.filteredCountries.find(country => country.dial_code == this.form.phoneCode)
      this.$emit("update:phoneCode", this.form.phoneCode)
      this.$emit("update:countryName", data.name)
      this.$emit("update:countryCode", data.code)
      this.$emit("update:flagImage", data.flag_image) 
    },
    onSelect() {
      let data = this.filteredCountries.find(country => country.dial_code == this.form.phoneCode)
      this.$emit("update:phoneCode", data.dial_code)
      this.$emit("update:countryName", data.name)
      this.$emit("update:countryCode", data.code)
      this.$emit("update:flagImage", data.flag_image)
      this.$emit("onSelect", {
        countryName: data.name,
        countryCode: data.dial_code,
        flagImage: data.flag_image
      })
    },
    onMenuChange(val) {
      if (!val) {
        this.searchCountry = ''
      }
    }
  }
  
}
</script>

<style lang="scss" scoped>
.custom-dropdown  {
  margin: 100px !important;
  padding: 100px !important;
}
.v-list {
  padding: 0 !important;
}
</style>